import { DASH } from '@/globals';
import formatNumber from '@/utils/NumberFormatter';
import Validatable from '@/validator/Validatable';
import i18n from '@/vueI18n';

interface ILineItemDeliveryAPI {
  type?: string;
  lineitem_id: number;
  lineitem_name: string;
  cpm?: number;
  spend?: number;
  impressions?: number;
}

interface ILineItemDelivery {
  type: string;
  id: number;
  name: string;
  cpm: number;
  spend: number;
  impressions: number;
}

export default class LineItemDelivery extends Validatable {
  type: string;

  name: string;

  cpm?: number;

  impressions?: number;

  spend?: number;

  apiObject?: ILineItemDeliveryAPI;

  constructor(id = -1, name = '', cpm?: number, impressions?: number, spend?: number, type?: string) {
    super();
    this.type = type || 'LineItemDelivery';
    this.id = id;
    this.name = name;
    this.cpm = cpm;
    this.impressions = impressions;
    this.spend = spend;
    this.apiObject = null;
  }

  get endpoint(): string {
    return `/lineitems/${this.id}`;
  }

  get cpmFormatted(): string {
    return this.cpm != null ? i18n.global.n(this.cpm, 'currency') : DASH;
  }

  get impressionsFormatted(): string {
    return this.impressions != null ? formatNumber(this.impressions, '0,0') : formatNumber(0, '0,0');
  }

  get spendFormatted(): string {
    return this.spend != null ? i18n.global.n(this.spend, 'currency') : DASH;
  }

  clone(name?: string): LineItemDelivery {
    return LineItemDelivery.fromObject({
      type: this.type,
      id: this.id,
      name: name != null ? name : this.name,
      cpm: this.cpm,
      spend: this.spend,
      impressions: this.impressions,
    });
  }

  static fromObject(obj: ILineItemDelivery): LineItemDelivery {
    return super.fromObject(obj, new LineItemDelivery());
  }

  static fromApi(apiObject: ILineItemDeliveryAPI): LineItemDelivery {
    const obj = {
      type: apiObject.type ? apiObject.type : null,
      id: apiObject.lineitem_id,
      name: apiObject.lineitem_name,
      cpm: apiObject.cpm,
      spend: apiObject.spend,
      impressions: apiObject.impressions,
    };
    const lineItem = LineItemDelivery.fromObject(obj);
    lineItem.apiObject = apiObject;
    return lineItem;
  }
}
